import { Grid, IconButton, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { X } from 'ts-react-feather-icons';

import { CustomResultItemField } from '../utils/custom-result-item-field';

type Props = {
  customField: CustomResultItemField;
  // eslint-disable-next-line @typescript-eslint/ban-types
  updateCustomField: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleRemoveClick: Function;
};

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  inputField: {
    textAlign: 'left',
    width: '100%',
  },
  removeButton: {},
}));

export default function NewEssentialData({
  customField,
  updateCustomField,
  handleRemoveClick,
}: Props) {
  const classes = useStyles();

  const onCustomFieldFieldChange = (e: any) => {
    customField.field = e.target.value;
    updateCustomField(customField);
  };

  const onCustomFieldValueChange = (e: any) => {
    customField.value = e.target.value;
    updateCustomField(customField);
  };

  const onRemoveClick = () => {
    handleRemoveClick();
  };

  return (
    <>
      <Grid className={classes.container}>
        <IconButton onClick={onRemoveClick} size="large">
          <X />
        </IconButton>
        <Grid item xs={6} sm={6}>
          <TextField
            className={classes.inputField}
            fullWidth
            label="Field"
            name="name"
            value={customField.field}
            variant="outlined"
            onChange={onCustomFieldFieldChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <TextField
            className={classes.inputField}
            fullWidth
            label="Value"
            name="value"
            value={customField.value}
            variant="outlined"
            onChange={onCustomFieldValueChange}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </Grid>
    </>
  );
}
